import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    on: translate({ id: 'global.on' }),
    off: translate({ id: 'global.off' }),
    roadEdits: translate({ id: 'global.roadEdits' }),
    noRoadEdits: translate({ id: 'globalStyles.roadEdits.noRoadEdits' }),
  }))

  return api
}
